import angieIllustration from '../static/images/sectionTalking/2015/angie-illustration.png';
import angiePhoto from '../static/images/sectionTalking/2015/angie.png';
import kaiIllustration from '../static/images/sectionTalking/2015/kai-illustration.png';
import kaiPhoto from '../static/images/sectionTalking/2015/kai.png';
import kuanIllustration from '../static/images/sectionTalking/2015/kuan-illustration.png';
import kuanPhoto from '../static/images/sectionTalking/2015/kuan.png';
import awonIllustration from '../static/images/sectionTalking/2015/awon-illustration.png';
import awonPhoto from '../static/images/sectionTalking/2015/awon.png';
import stellaIllustration from '../static/images/sectionTalking/2015/stella-illustration.png';
import stellaPhoto from '../static/images/sectionTalking/2015/stella.png';
import hanIllustration from '../static/images/sectionTalking/2015/han-illustration.png';
import hanPhoto from '../static/images/sectionTalking/2015/han.png';

export default [
    {
        name: "ANGIE",
        position: "Front-End Developer",
        img: angieIllustration,
        photo: angiePhoto,
        article: `<p>在新芽實習的日子，有非常多的成長與感謝，在這裡就長話短說好了。</p>
                  <p> 先說說技術的部分，因為我本身是定義自己是一個設計比前端 7:3 的混血前端設計師，\
但是其實兩邊都還沒有到自己覺得很擅長，但是最近看著自己剛進來新芽的作品，還有最近的作品，\
真的是有驚人的成長呀！當初真是慘不忍睹QQ 具體來說我從只有 css 加一點點JS進入了scss加更多的JS，\
從只有PS,AI進入了Sketch（一種神奇寶貝進化的感覺）在實作時，也變得更加順手，\
解決問題跟發想靈感的效率也增加了。這些成長當然是歸功於google大神還有更多是夥伴的教導。
                  </p>
                  <p>於是來談談夥伴們，在新芽的大家很像是社團夥伴們，\
一起做專案，一起研究新事物，許多很有耐心的學長姐會傾囊相授，並且給你許多機會讓你去發揮，\
還有一群會跟你一起在下班後開辦公室投影機一起看coursera的同屆生，
大家總是的相處總是充滿了垃圾話（我都只會負責笑啦QQ 但是負責笑的人應該也蠻重要的），\
當然，認真討論正事的時候也是嚴肅中參雜了輕鬆的話語，\
讓整個辦公室的氛圍令人很自在，自在得讓人想讓自己變得更好。
                  </p>
                  <p>最後是關於自己的心境，在新芽的這些日子以來，\
會明顯的感覺到自己更加願意去觸碰對自己來說很新的事物，並且願意發揮科學家的精神去實驗，\
但是也明顯會了解到自己尚有非常多進步的空間，然後更想要進步了！
                  </p>
                  <p>以上就是我個人簡短的心情分享，在這裡真的是感覺心裡滿滿的，\
很踏實很溫暖。至於新芽的福利之好的，我想我就不用再多說了，大家別猶豫快投履歷吧～
                  </p>`
    },
    {
        name: "KAI",
        position: "Front-End Developer",
        img: kaiIllustration,
        photo: kaiPhoto,
        article: `<p>昔大三，欲尋實習機會以拓展己志，經友之言聞新芽網路，先前已尋多家實習，擇新芽已是多慮後之也。</p>
                <p>好啦其實我國文超爛 der，我只是想表達在這裡工作可以多麼輕鬆，我才不會正經八百地介紹咧～</p>
                <p>身為資管系，從大一就接受過許多資訊的訓練，但一直到大三那年才開始學習開發網站的種種，產生了興趣以後就想找間公司實習實際把自己所學的應用在專案上面，接案公司的好處就是你可以不斷接觸不同的專案，今天想在這個專案用 Angular 就用，改天可以在別的專案使用 React ，公司也不排斥使用新穎的技術（當然還是要穩定且符合客戶需求為主），來這邊後很多時候都是靠自己自主學習，雖然我們人少可能想使用的技術還沒有人學過，但大家也都會很樂意幫忙的。</p>
                <p>除了接案以外新芽也有自己的產品 (SurveyCake)，所以不想面對難纏的客戶的話也是有別的選擇的哈哈～</p>
                <p>福利我想就不用說了，面試了那麼多家後這裡可以肯定是福利最好的，我相信大概也很難找到任何一家新創公司有辦法提供這樣的福利，身為 1% 的新創頭頭當然對於員工是百分百的尊重，其中我最喜歡的是今年開始每個月定期舉辦的 workshop 還可以讓你固定吸收新知，保持頭腦健康茁壯哦！噢對了我說過還可以跟貓界的校花玩嗎？</p>
                <p>There is nothing to be considered (I’ve done it for you), join 25sprout, and experience it yourself.</p>`
    },
    {
        name: "KUAN",
        position: "APP Developer",
        img: kuanIllustration,
        photo: kuanPhoto,
        article: `<p>待在新芽的一年裡心情經歷了好幾個階段的轉換～</p>
                <p>還記得一年前在FB的某個社團上看到新芽招募實習生的訊息，印象最深刻的就是招募網站上活力的配色與可愛的插圖，當時的我對 iOS 與 專案管理實習職缺最有興趣，除了網站吸睛地讓我專心看完每一個細節，徵才文案更是讓我自戀的認為這就是專屬於我的工作，（「我們在尋找一位天真浪漫的人，你不必是雙魚座，但你必須傻得徹底， 打從心裡堅信這個世界將因為你所開發的App而產生變化，人們的生活也因此更加地便利。」- 新芽）自己並非資訊本科系出身，與 iOS 唯一關聯就是曾經跑去旁聽資工系的 iOS 課程，或許就是那股傻勁讓我不畏懼的投出履歷。</p>
                <p>一開始很擔心只會拿老師PPT來寫code的我，到底會不會造成新芽的困擾？很幸運新芽有群熱情的Mentor 帶我一步步打底學習，並細心地回答我那完全沒程式概念邏輯所提出的問題 :P由於實習生裡我最菜，當他們都已經開始進行專案開發時，只有我一人還在做練功題一步步學習，有時候壓力蠻大的，還好辦公室有舒服的沙發區與吃不完的零食，讓尚未適應的我有個溫馨的窩幫助我消化，雖然學習路上內心難免會有低潮，但回想起來在這邊工作是最幸福甜蜜的，每天大家一起吃飯、每季大家一起看電影、與每年一同旅遊的歡樂和感動，都是實習這年最珍貴的回憶。</p>
                <p>公司正在進行一項CSR專案，也是屬於我的第一個正式專案，從開會討論、制定時程到分工，都讓我興奮不已，開發的過程中，打從心裡堅信這個社會將因為新芽所開發的App而產生變化，由於在新芽實習所累積的感動，讓現在的我更能勝任不同階段遇到的困難，而這些都是在學校難以學習的真實社會歷練。</p>
                <p>如果你也期待有個難忘的實習經歷，歡迎你跟我一樣用那股傻勁勇敢的投出履歷吧！：）</p>`
    },
    {
        name: "AWON",
        position: "APP Developer",
        img: awonIllustration,
        photo: awonPhoto,
        article: `<p>你說進入了新芽到底有神馬感覺？</p>
                  <p>映入眼廉，新芽是一間有活力、熱情的新創公司<br/>
                     如你看見，我上下左右旁邊的各式各樣心得，可能都有如此感受：<br/>
                     「媽呀！天天上班有預備好的各種零食、茶包、咖啡可以盡情享用」<br/>
                     「今天又到了訂零食時間，我要讓公司代替我逞罰義美」<br/>
                     「自從來了公司後，都不用帶錢包吃午餐太爽啦～」<br/>
                     「上班回個社群訊息不用擔心被老闆看到會被OOXX，沒事兒！」<br/>
                     「昨天看發表會睡晚了，今天晚下班就好ก็ʕ•͡ᴥ•ʔก้」<br/>
                     「每季電影之夜、生日慶生、交換禮物、運動會，好多活動可以跟同事相處，原來同事一點都不宅」<br/>
                     「辦公室超級舒適的環境，躺著寫、坐著寫、趴著寫，還是在公司最適合寫扣」</p>
                  <p>也許你看到的是「福利超啵棒」、「環境輕鬆無負擔」的關鍵字</p>
                  <p>我認為最重要的地方在於──<br/>
                     新芽給予了「獨一無二的歸屬感」٩(๑•̀ω•́๑)۶</p>
                  <p>專案卡關的時候，可以大方的去同事身邊請教或害羞點可以敲 Slack 詢問，不用擔心自己問了笨問題，因為每個人都會遇到問題，大家也都非常樂意分享自身的經驗，而且在設計架構上的討論也不侷限於相關領域的同事，就像我常常看到 iOS 的問題不只會去問 APP Team 的人，也會問問後端 Team 是怎麼解，思路解法與技術交流，絕對是成長的最佳養分。</p>
                  <p>而一間有歸屬感的公司，才不會是「上班好同事、下班不認識」的曖昧情誼，垃圾話每天充斥在我們的聊天頻道，還有人幫你注意 3C 特價呢A__A</p>
                  <p>在工作之中，保有生活的樂趣與彈性，人生幸福沒有之一啊啊啊XD</p>
                  <p>不多說了～趕快留給各位觀眾更多時間去用履歷啊XDDD<br/>
                  你，快來成為 Sprouter 吧！ :)</p>`
    },
    {
        name: "STELLA",
        position: "Administration Specialist",
        img: stellaIllustration,
        photo: stellaPhoto,
        article: `<p>安扭，我是Stella～</p>
                  <p>與優秀的實習生同事們不同，我不是在第二屆實習計畫與夥伴們一起加入的，因此沒有經歷那段競爭激烈的名額搶奪戰>///< 大學畢業後準備到英國闖蕩，中間這年決定來台北流浪。十分幸運的透過當時成為第二屆實習生的Han得知新芽在招募完實習生後，尚缺行政助理一職，於是流浪的我就如同找到浮木一樣，立馬寄了履歷，還在面試時準備了長篇大論的自我介紹為了進入這個夢幻企業(現在回想覺得有點菜哈哈)，到今天我都覺得像做夢一般幸運，因為新芽真！的！比！想！像！中！還！棒 ！</p>
                  <p>行政小妹的工作量雖然沒別人多，但更多的時間讓我可以偷偷觀察同事並學習，還有一個超級好處就是身為萬用人可以穿梭在公司各個專案，因此就可以在各個專案群組裡搜集八卦(大誤)，沒有啦是可以從各專案中熟悉公司運作方式、與客戶間如何互動以及每個同事習慣的合作方式，對於未來想當PM的我是很棒的學習契機。</p>
                  <p>在新芽工作也不需要有太大的壓力，這裡的大家都熱愛自己的工作，而且大家會鼓勵你想休息就休息，身為公司唯一哈韓迷妹的我，閒暇時間還可以看一下偶像滋潤身心靈，不小心被發現也沒關係，大家只會哈拉說這是誰，怎麼這麼帥(咦這句是腦補吧)，啊但意思不是可以打混，新芽大夥都是很有責任使命才這麼團結能完成各種帥氣專案的唷～</p>
                  <p>CFO學妹對從小就想養貓的我來說是最棒的福利(淚)，偶爾假日來公司獨佔學妹就是我生活的小確幸(學妹：喵我只是要你來幫我鏟屎沒有要理你)。此外還有很棒的零食吧，都要捏一把自己的肥肉才能克制不要吃太多，而且每天都可以睡到很晚起床因為十點才上班！！這是什麼超級幸福企業啊嗚嗚QAQ</p>
                  <p>落落長說了一堆還是講不完新芽的好，甚至都會覺得捨不得離開乾脆不要去留學好了(亂講)，總之，想像我一樣跳脫傳統嗎？快來加入我們吧！！</p>`
    },
    {
        name: "HAN",
        position: "Back-End Developer",
        img: hanIllustration,
        photo: hanPhoto,
        article: `<p>大學是讀資訊管理，原本想遠離寫程式的世界，研究所就選了科技管理，殊不知意外開啟了我進入新芽，當起後端實習生一年的生活⋯⋯</p>
                  <p>由於我不像其他實習生都是強而有力的技術性人才，那就來聊聊我的菸酒生實習日記，台北台中兩地當飛人的心路歷程吧(泣)，菸酒生不同於大學生除了上課以外，還必須跟教授meeting準備論文，時間分配上必須要好好拿捏，利用假日把論文進度完成是不需要太意外的。要是還有另一半要照顧的話，更會分身乏術，最好的辦法就是把另一半也一起找來新芽(大誤)。</p>
                  <p>進入新芽的日子比較晚，七月初還先去了英國三個禮拜，當初抱著忐忑不安的信寫信給Alex說晚點才能上班，結果Alex居然說，都去那麼遠了，要不要去久一點，這是我第一次感受到新創公司的活力。回國之後，自己一個人跟著Alex的新生訓練，提到了新芽的偶像，創業的精神與典範，然後說可能明年會搬辦公室，原本想說不了了之，這個想法後來我就在Outing時提出，大家又熱烈討論了一個禮拜，在以為又無疾而終之時，Alex跟駭客在四月的某一天突然告訴大家，看了一間超棒的辦公室，準備搬家囉，哇！有種小小實習生心聲被聽到的感覺。今年才開始的workshop、運動會，都是Alex與駭客跟大家討論出來的成果，當然討論的時候不免夾雜著一些垃圾話，但這也是新芽的傳統之一啦。對了，如果喜歡運動，還會有人揪團參加三鐵唷，結果最後揪團的人自己要去出差就中離了⋯⋯</p>
                  <p>在極度水平化的新芽，會跟不同的人搭配到各種有趣(?)的專案，在執行專案遇到困難時，各種神人都可以讓你發問，學妹也會偶爾趁你不注意的時候幫你coding。在新芽的實習期間，每天都是一種練習，練習如何把生活跟工作快樂的結合，在這些日子裡，無庸質疑，我很快樂。</p>`
    }
]



// WEBPACK FOOTER //
// ./src/models/Sprouters2015.js